export default __webpack_public_path__ + "static/media/inlineImage.0199e704.svg";